import Markdown from "react-markdown"
import remarkGfm from "remark-gfm"

interface Props {
  source: string
  className?: string
}

export default function MarkdownPreview({ source, className }: Props) {
  const trimmed = source.trim()

  if (trimmed.length === 0) {
    return (
      <p className="text-muted-foreground text-sm italic">
        Nothing to preview yet.
      </p>
    )
  }

  return (
    <div
      className={[
        "prose prose-sm dark:prose-invert max-w-none break-words",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <Markdown remarkPlugins={[remarkGfm]}>{source}</Markdown>
    </div>
  )
}
